
import { defineComponent } from "vue";
import { usePlugin } from "@/plugins";
import { useSessionStorage } from "@vueuse/core";
import InputCourse from "@/components/InputCourse.vue";
import InputUser from "@/components/InputUser.vue";
import InputQuestion from "@/components/InputQuestion.vue";
import { GetTrainingReportRequest } from "@/types";
import { saveAs } from "file-saver";

export default defineComponent({
  name: "TrainingReport",
  components: { InputCourse, InputUser, InputQuestion },
  setup() {
    const { setLoading, dayjs, axios, success, error } = usePlugin();
    const query = useSessionStorage("trainingReport-query", {
      courseId: null,
      userId: null,
      questionId: null,
      selectedDate: [
        dayjs()
          .startOf("month")
          .toDate(),
        dayjs()
          .endOf("month")
          .toDate(),
      ],
    });
    query.value.selectedDate[0] = dayjs(query.value.selectedDate[0]).toDate();
    query.value.selectedDate[1] = dayjs(query.value.selectedDate[1]).toDate();

    const downloadReport = async () => {
      setLoading(true);
      try {
        const result = await axios.post(
          "api/v1/services/report/training",
          {
            selectedDate: query.value.selectedDate,
            questionId: query.value.questionId,
            courseId: query.value.courseId,
            employeeId: query.value.userId,
          } as GetTrainingReportRequest,
          {
            responseType: "blob",
            timeout: 300000,
            timeoutErrorMessage: "หมดเวลาการเชื่อมต่อ กรุณาลองใหม่ภายหลัง",
          }
        );

        saveAs(result.data);

        success("ดึงข้อมูลสำเร็จแล้ว");
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    return {
      query,
      downloadReport,
    };
  },
});
